import {AsyncPipe} from '@angular/common';
import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {TranslocoDirective} from '@jsverse/transloco';
import {interval, take, tap} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {TIMER_INTERVAL, TIMER_STEPS} from './redirect.config';

@Component({
    selector: 'dvlib-redirect',
    imports: [
        AsyncPipe,
        TranslocoDirective,
    ],
    templateUrl: './redirect.component.html',
    styles: `
        :host {
            display: block;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RedirectComponent {
    public targetUrl = input.required<string>();

    public redirectDelay$ = interval(TIMER_INTERVAL).pipe(
        map(i => TIMER_STEPS - i - 1),
        take(TIMER_STEPS),
        startWith(TIMER_STEPS),
        tap({complete: () => globalThis.location.href = this.targetUrl()}),
        takeUntilDestroyed(),
    );
}
